export const NuxtLogo = () => import('../../components/NuxtLogo.vue' /* webpackChunkName: "components/nuxt-logo" */).then(c => wrapFunctional(c.default || c))
export const Tutorial = () => import('../../components/Tutorial.vue' /* webpackChunkName: "components/tutorial" */).then(c => wrapFunctional(c.default || c))
export const BackTop = () => import('../../components/BackTop/index.vue' /* webpackChunkName: "components/back-top" */).then(c => wrapFunctional(c.default || c))
export const DynamicForm = () => import('../../components/DynamicForm/index.vue' /* webpackChunkName: "components/dynamic-form" */).then(c => wrapFunctional(c.default || c))
export const Footer = () => import('../../components/Footer/index.vue' /* webpackChunkName: "components/footer" */).then(c => wrapFunctional(c.default || c))
export const Header = () => import('../../components/Header/index.vue' /* webpackChunkName: "components/header" */).then(c => wrapFunctional(c.default || c))
export const Loading = () => import('../../components/Loading/index.vue' /* webpackChunkName: "components/loading" */).then(c => wrapFunctional(c.default || c))
export const NavBar = () => import('../../components/NavBar/index.vue' /* webpackChunkName: "components/nav-bar" */).then(c => wrapFunctional(c.default || c))
export const PossWord = () => import('../../components/PossWord/index.vue' /* webpackChunkName: "components/poss-word" */).then(c => wrapFunctional(c.default || c))
export const Recommend = () => import('../../components/Recommend/index.vue' /* webpackChunkName: "components/recommend" */).then(c => wrapFunctional(c.default || c))
export const VideoNuxt = () => import('../../components/VideoNuxt/index.vue' /* webpackChunkName: "components/video-nuxt" */).then(c => wrapFunctional(c.default || c))
export const GiftBagCenter = () => import('../../components/giftBagCenter/index.vue' /* webpackChunkName: "components/gift-bag-center" */).then(c => wrapFunctional(c.default || c))
export const Slider = () => import('../../components/slider/index.vue' /* webpackChunkName: "components/slider" */).then(c => wrapFunctional(c.default || c))
export const SvgIcon = () => import('../../components/svgIcon/index.vue' /* webpackChunkName: "components/svg-icon" */).then(c => wrapFunctional(c.default || c))
export const SwiperCpt = () => import('../../components/swiperCpt/index.vue' /* webpackChunkName: "components/swiper-cpt" */).then(c => wrapFunctional(c.default || c))
export const SwiperPag = () => import('../../components/swiperPag/index.vue' /* webpackChunkName: "components/swiper-pag" */).then(c => wrapFunctional(c.default || c))
export const Verification = () => import('../../components/verification/index.vue' /* webpackChunkName: "components/verification" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
